import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const areaOfUsesApi = createApi({
  reducerPath: 'areaOfUsesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getAreaOfUses: builder.query({
      query: () => ({
        url: urls.fijAreaOfUses,
      }),
    }),
  }),
});

export const { useGetAreaOfUsesQuery } = areaOfUsesApi;
